'use client';

import { c as _c } from "react/compiler-runtime";
import { Card } from '@achra/ui/card';
import type { Budget } from '@/modules/finances/types';
import { TitleSectionFinances } from '../../title-section-finances';
import { ReservesWaterfallChartFilters } from '../reserves-waterfall-chart-filters';
import { ReservesWaterfallChartGraph } from '../reserves-waterfall-chart-graph';
import { ReservesWaterfallChartSkeleton } from '../reserves-waterfall-chart-skeleton';
import { useReservesWaterfallChart } from '../use-reserves-waterfall-chart';
const TOOLTIP_CONTENT = <div className="flex flex-col gap-2">
    <p className="m-0">
      Monitor the dynamics of Sky&apos;s reserves with precision using this interactive financial
      chart.
    </p>
    <p className="m-0">
      It displays detailed inflows, outflows, and net balances, providing a clear picture of fiscal
      health. Customize the analysis by filtering specific data points and adjusting the timeline to
      suit your needs.
    </p>
    <p className="m-0">
      Utilize this tool to identify trends in reserve movements, evaluate the sustainability of
      reserves, and guide strategic financial planning.
    </p>
  </div>;
interface ReservesWaterfallChartInternalProps {
  codePath: string;
  budgets: Budget[];
  allBudgets: Budget[];
  year: string;
}
function ReservesWaterfallChartInternal(t0) {
  const $ = _c(33);
  const {
    codePath,
    budgets,
    allBudgets,
    year
  } = t0;
  let t1;
  if ($[0] !== allBudgets || $[1] !== budgets || $[2] !== codePath || $[3] !== year) {
    t1 = {
      codePath,
      budgets,
      allBudgets,
      year
    };
    $[0] = allBudgets;
    $[1] = budgets;
    $[2] = codePath;
    $[3] = year;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    titleChart,
    isLoading,
    series,
    selectedGranularity,
    selectedGranularityFilter,
    setSelectedGranularity,
    granularityOptions,
    categoryOptions,
    selectedCategoryOptions,
    setActiveElements,
    canReset,
    onReset
  } = useReservesWaterfallChart(t1);
  let t2;
  if ($[5] !== granularityOptions) {
    t2 = granularityOptions.map(_temp);
    $[5] = granularityOptions;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const granularityValues = t2;
  const t3 = `Jan - Dec ${year}`;
  let t4;
  if ($[7] !== t3 || $[8] !== titleChart) {
    t4 = <TitleSectionFinances title={titleChart} hash="reserves-waterfall-chart" tooltipContent={TOOLTIP_CONTENT} range={t3} />;
    $[7] = t3;
    $[8] = titleChart;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== granularityOptions || $[11] !== setSelectedGranularity) {
    t5 = selectedValue => {
      const option_0 = granularityOptions.find(item => item.value === selectedValue);
      if (option_0) {
        setSelectedGranularity(option_0.value);
      }
    };
    $[10] = granularityOptions;
    $[11] = setSelectedGranularity;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== canReset || $[14] !== categoryOptions || $[15] !== granularityValues || $[16] !== onReset || $[17] !== selectedCategoryOptions || $[18] !== selectedGranularityFilter || $[19] !== setActiveElements || $[20] !== t5) {
    t6 = <ReservesWaterfallChartFilters granularityValue={selectedGranularityFilter} granularityOptions={granularityValues} onGranularityChange={t5} categoryOptions={categoryOptions} selectedCategoryOptions={selectedCategoryOptions} setActiveElements={setActiveElements} canReset={canReset} onReset={onReset} />;
    $[13] = canReset;
    $[14] = categoryOptions;
    $[15] = granularityValues;
    $[16] = onReset;
    $[17] = selectedCategoryOptions;
    $[18] = selectedGranularityFilter;
    $[19] = setActiveElements;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t4 || $[23] !== t6) {
    t7 = <div className="flex flex-row flex-wrap items-start justify-between gap-2">{t4}{t6}</div>;
    $[22] = t4;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== isLoading || $[26] !== selectedGranularity || $[27] !== series || $[28] !== year) {
    t8 = isLoading ? <ReservesWaterfallChartSkeleton /> : <ReservesWaterfallChartGraph year={year} selectedGranularity={selectedGranularity} series={series} />;
    $[25] = isLoading;
    $[26] = selectedGranularity;
    $[27] = series;
    $[28] = year;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t7 || $[31] !== t8) {
    t9 = <Card className="bg-popover flex w-full flex-col gap-4 border-none p-2 pb-4 shadow-xs md:gap-6 md:p-4 lg:px-6 lg:pb-6">{t7}{t8}</Card>;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
}
function _temp(option) {
  return option.value;
}
export { ReservesWaterfallChartInternal };